import { render, staticRenderFns } from "./EditarProveedor.vue?vue&type=template&id=08b19d5d"
import script from "./EditarProveedor.vue?vue&type=script&lang=js"
export * from "./EditarProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports